// authentication.service.ts
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AUTH } from 'src/app/constant/constant';

@Injectable()
export class AuthenticationService {
    private sub: Subscription;

    constructor(protected http: HttpClient) {

    }

    getUser() {
        return localStorage.getItem(AUTH.USER_INFO_KEY);
    }

    getToken() {
        return localStorage.getItem(AUTH.TOKEN_KEY);
    }

    getTokenKeycloak() {
        return localStorage.getItem(AUTH.TOKEN_KEY_KEYCLOAK);
    }

    getExpiresIn() {
        return localStorage.getItem(AUTH.EXPIRES_IN);
    }

    getRefreshToken() {
        return localStorage.getItem(AUTH.REFRESH_TOKEN_KEY_KEYCLOAK);
    }

    // login(loginRequest: any) {

    //     let headers = new Headers({ 'Content-Type': 'application/json' });
    //     let requestoptions = {
    //         method: "POST",
    //         url: "/api/v1/auth/signin",
    //         headers: headers,
    //         body: JSON.stringify(loginRequest)
    //     };

    //     return this.http.request(new Request(requestoptions))
    //         .map((response: Response) => {
    //             // login successful if there's a jwt token in the response
    //             let token = response.json() && response.json().token;
    //             if (token) {
    //                 // Store user info
    //                 let user: any;
    //                 user = response.json().user;

    //                 let date = this.getTokenExpirationDate(token);

    //                 var expiration = (date.valueOf() - new Date().valueOf());
    //                 //console.log("Token expiration : " + date);
    //                 return { user: user, token: token, loginType: LOGIN_TYPE.LOGIN_NORMAL };
    //             }
    //             return { user: null, token: null, loginType: LOGIN_TYPE.LOGIN_NORMAL };
    //         })
    //         .catch(error => {
    //             return Observable.throw(error);
    //         });
    // }

    // logout() {

    //     let jsonHeaders = new Headers(
    //         {
    //             'Authorization': 'Bearer ' + this.getToken()
    //         });

    //     let requestoptions = new RequestOptions({
    //         method: RequestMethod.Post,
    //         url: "/api/logout",
    //         headers: jsonHeaders,
    //         body: ""
    //     });

    //     return this.http.request(new Request(requestoptions))
    //         .map((res: Response) => {
    //             localStorage.removeItem('r');
    //             localStorage.removeItem(AUTH.USER_INFO_KEY);
    //             localStorage.removeItem(AUTH.TOKEN_KEY);

    //             this.sub.unsubscribe();
    //         });
    // }

    isLoggedIn() {
        var token = localStorage.getItem(AUTH.TOKEN_KEY);
        return token != null && token != "" && !this.isTokenExpired(token);
    }

    public urlBase64Decode(str: string): string {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: { break; }
            case 2: { output += '=='; break; }
            case 3: { output += '='; break; }
            default: {
                throw 'Illegal base64url string!';
            }
        }
        return this.b64DecodeUnicode(output);
    }

    // // credits for decoder goes to https://github.com/atk
    private b64decode(str: string): string {
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output: string = '';

        str = String(str).replace(/=+$/, '');

        if (str.length % 4 == 1) {
            throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
        }

        for (
            // initialize result and counters
            let bc: number = 0, bs: any, buffer: any, idx: number = 0;
            // get next character
            buffer = str.charAt(idx++);
            // character found in table? initialize bit storage and add its ascii value;
            ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
                // and if not first of each 4 characters,
                // convert the first 8 bits to one ascii character
                bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
        ) {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        return output;
    }

    // https://developer.mozilla.org/en/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
    private b64DecodeUnicode(str: any) {
        return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    public decodeToken(token: string): any {
        let parts = token.split('.');

        if (parts.length !== 3) {
            throw new Error('JWT must have 3 parts');
        }

        let decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
            throw new Error('Cannot decode the token');
        }

        return JSON.parse(decoded);
    }

    public getTokenExpirationDate(token: string): Date {
        let decoded: any;
        decoded = this.decodeToken(token);

        if (!decoded.hasOwnProperty('exp')) {
            return null;
        }

        let date = new Date(0); // The 0 here is the key, which sets the date to the epoch
        date.setUTCSeconds(decoded.exp);

        return date;
    }

    public isTokenExpired(token: string, offsetSeconds?: number): boolean {
        let date = this.getTokenExpirationDate(token);
        offsetSeconds = offsetSeconds || 0;

        if (date == null) {
            return false;
        }

        var isExpired = !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));

        // Token expired?
        return isExpired;
    }
}
